import { useState, useEffect, useRef, useCallback } from 'react';

import Dashboard from './Dashboard';
import Quantiply from './Quantiply';
import AMB2 from './AMB2';
import AMB3 from './AMB3';
import SuperStraddle2 from './SuperStraddle2';
import SuperStraddle3 from './SuperStraddle3';
import OptionChain from './OptionChain';
import IVSurface from './IVSurface';
import HybridConviction from './HybridConviction';
import GammaExposure from './GammaExposure';
import Positioning from './Positioning';
import OIAnalysis from './OIAnalysis';
import OIRideD1 from './OIRideD1';
import OIRideR from './OIRideR';
import DirectionalTV from './DirectionalTV';
import DirectionalTV1 from './DirectionalTV1';
import OIRideRLive from './OIRideRLive';
import OIWalls3x from './OIWalls3x';
import OIWalls2x from './OIWalls2x';
import OIWallsLive from './OIWallsLive';
import OIWalls3xLive from './OIWalls3xLive';
import GEXWallsLive from './GEXWallsLive';
import StraddleTracker from './StraddleTracker';
import Logs from './Logs';
import Orders from './Orders';

var STORE_KEY = 'algrok_workspace';
var COLS = 3;

var PAGES = [
  { id: 'none', label: '— empty —', el: null },
  { id: 'dashboard', label: 'Dashboard', el: Dashboard },
  { id: 'orders', label: 'Orders', el: Orders },
  { id: 'logs', label: 'Logs', el: Logs },
  { id: 'optionchain', label: 'Option Chain', el: OptionChain },
  { id: 'oi', label: 'OI Ladder', el: OIAnalysis, props: { initialView: 'ladder' } },
  { id: 'oi_candles', label: 'OI Flow Candles', el: OIAnalysis, props: { initialView: 'candles' } },
  { id: 'gex', label: 'Gamma Exposure', el: GammaExposure },
  { id: 'positioning', label: 'Positioning', el: Positioning },
  { id: 'ivsurface', label: 'IV Surface', el: IVSurface },
  { id: 'hybrid', label: 'Hybrid Conviction', el: HybridConviction },
  { id: 'straddle', label: 'Straddle Tracker', el: StraddleTracker },
  { id: 'oirided1', label: 'OI Ride D-1', el: OIRideD1 },
  { id: 'oirider', label: 'OI Ride-R', el: OIRideR },
  { id: 'directional_tv', label: 'Directional TV', el: DirectionalTV },
  { id: 'directional_tv1', label: 'Directional TV-1', el: DirectionalTV1 },
  { id: 'oiride_r_live', label: 'OI Ride-R LIVE', el: OIRideRLive },
  { id: 'oiwalls3x', label: 'OI Walls 3x', el: OIWalls3x },
  { id: 'oiwalls2x', label: 'OI Walls 2X', el: OIWalls2x },
  { id: 'quantiply', label: 'Quantiply', el: Quantiply },
  { id: 'amb2', label: 'AMB2', el: AMB2 },
  { id: 'amb3', label: 'AMB3', el: AMB3 },
  { id: 'super_straddle_2', label: 'Super Straddle 2', el: SuperStraddle2 },
  { id: 'super_straddle_3', label: 'Super Straddle 3', el: SuperStraddle3 },
  { id: 'oiwalls_live', label: 'OI Walls LIVE', el: OIWallsLive },
  { id: 'oiwalls3x_live', label: 'OI Walls 3x LIVE', el: OIWalls3xLive },
  { id: 'gexwalls_live', label: 'GEX Walls LIVE', el: GEXWallsLive },
];

function pageById(id) {
  for (var i = 0; i < PAGES.length; i++) if (PAGES[i].id === id) return PAGES[i];
  return PAGES[0];
}

var POLL_TTL = { 1: 900, 2: 2000, 5: 5000 };
var ZOOM_MIN = 0.5;
var ZOOM_MAX = 1.5;

function zoomBtn(off) {
  return {
    cursor: off ? 'default' : 'pointer', fontFamily: 'inherit',
    background: 'transparent', color: off ? '#3a4556' : '#8b98a9',
    border: '1px solid ' + (off ? '#1b2534' : '#26334a'), borderRadius: 4,
    fontSize: 11, fontWeight: 800, lineHeight: 1, padding: '2px 6px',
  };
}
var SEED = ['dashboard', 'optionchain', 'oi_candles', 'oi', 'gex', 'orders',
            'oiwalls_live', 'gexwalls_live', 'logs'];

function rowsOf(n) { return Math.ceil(n / COLS); }
function paneCountInRow(n, r) { return Math.min(COLS, n - r * COLS); }

function freshGeometry(n) {
  var cols = [], heights = [];
  for (var r = 0; r < rowsOf(n); r++) {
    var row = [];
    for (var c = 0; c < paneCountInRow(n, r); c++) row.push(1);
    cols.push(row);
    heights.push(1);
  }
  return { cols: cols, heights: heights };
}

function defaults(n) {
  var slots = [];
  for (var i = 0; i < n; i++) slots.push(SEED[i] || 'none');
  var g = freshGeometry(n);
  return { slots: slots, cols: g.cols, heights: g.heights, mult: 1, zoom: {} };
}

function load() {
  try {
    var raw = localStorage.getItem(STORE_KEY);
    if (!raw) return defaults(3);
    var s = JSON.parse(raw);
    if (!s || !Array.isArray(s.slots) || !s.slots.length) return defaults(3);
    if (!s.slots.some(function (x) { return x !== null; })) return defaults(3);
    var g = freshGeometry(s.slots.length);
    var colsOk = Array.isArray(s.cols) && s.cols.length === g.cols.length
      && s.cols.every(function (row, i) {
        return Array.isArray(row) && row.length === g.cols[i].length;
      });
    return {
      slots: s.slots,
      cols: colsOk ? s.cols : g.cols,
      heights: Array.isArray(s.heights) && s.heights.length === g.heights.length ? s.heights : g.heights,
      mult: POLL_TTL[s.mult] ? s.mult : 1,
      zoom: s.zoom && typeof s.zoom === 'object' ? s.zoom : {},
    };
  } catch (e) { return defaults(3); }
}

var Workspace = function () {
  var [st, setSt] = useState(load);
  var [hover, setHover] = useState(-1);
  var wrapRef = useRef(null);
  var dragRef = useRef(null);

  useEffect(function () {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(st)); } catch (e) { /* ignore */ }
  }, [st]);

  useEffect(function () {
    // Switch the shared-fetch layer ON for this page only. Panes live in one
    // JavaScript context so they can share a request; every other page opts
    // out and fetches directly.
    window.__algrokShareFetch = true;
    window.__algrokFetchTTL = POLL_TTL[st.mult] || 900;
    return function () {
      window.__algrokShareFetch = false;
      window.__algrokFetchTTL = 900;
      // Drop anything cached while the Workspace was open, so a page opened
      // straight afterwards can never read a stale body.
      window.__algrokRecent = {};
      window.__algrokInflight = {};
    };
  }, [st.mult]);

  var setCount = function (k) {
    setSt(function (p) {
      var slots = [];
      for (var i = 0; i < k; i++) {
        var keep = p.slots[i];
        slots.push(keep === null || keep === undefined ? (SEED[i] || 'none') : keep);
      }
      var g = freshGeometry(k);
      return { slots: slots, cols: g.cols, heights: g.heights, mult: p.mult, zoom: p.zoom || {} };
    });
  };

  var closePane = function (idx) {
    setSt(function (p) {
      var live = p.slots.filter(function (x) { return x !== null; }).length;
      if (live <= 1) return p;              // never close the last live pane
      var slots = p.slots.slice();
      // null = closed. Deliberately NOT spliced out: splicing shifts every
      // later pane up a position, so closing two in the top row would drag
      // the bottom row's panes into it. Leaving a hole keeps the grid shape,
      // and the survivors in THAT row expand across the freed width — which
      // is the point of closing them.
      slots[idx] = null;
      var g = freshGeometry(p.slots.length);
      return { slots: slots, cols: g.cols, heights: p.heights, mult: p.mult, zoom: p.zoom || {} };
    });
    setHover(-1);
  };

  var setSlot = function (idx, id) {
    setSt(function (p) {
      var s = p.slots.slice(); s[idx] = id;
      return Object.assign({}, p, { slots: s });
    });
  };

  // Step in 10% increments and clamp. Rounding to 2dp on every step stops
  // float drift turning 0.9 into 0.8999999999999999 in the readout.
  var stepZoom = function (idx, dir) {
    setSt(function (p) {
      var cur = (p.zoom || {})[idx] || 1;
      var next = Math.round((cur + dir * 0.1) * 100) / 100;
      if (next < ZOOM_MIN) next = ZOOM_MIN;
      if (next > ZOOM_MAX) next = ZOOM_MAX;
      var zm = Object.assign({}, p.zoom || {}); zm[idx] = next;
      return Object.assign({}, p, { zoom: zm });
    });
  };

  var setZoom = function (idx, z) {
    setSt(function (p) {
      var zm = Object.assign({}, p.zoom || {}); zm[idx] = z;
      return Object.assign({}, p, { zoom: zm });
    });
  };

  var onDown = function (kind, row, i, j) {
    return function (e) {
      e.preventDefault();
      var box = wrapRef.current ? wrapRef.current.getBoundingClientRect() : null;
      if (!box) return;
      dragRef.current = {
        kind: kind, row: row, i: i, j: (j === undefined ? i + 1 : j),
        x: e.clientX, y: e.clientY,
        w: box.width, h: box.height,
        cols: st.cols.map(function (c) { return c.slice(); }),
        heights: st.heights.slice(),
      };
    };
  };

  var onMove = useCallback(function (e) {
    var d = dragRef.current;
    if (!d) return;
    if (d.kind === 'col') {
      var per = d.w / Math.max(1, d.cols[d.row].length);
      var dw = (e.clientX - d.x) / per;
      var a = d.cols[d.row][d.i] + dw;
      var b = d.cols[d.row][d.j] - dw;
      if (a < 0.25 || b < 0.25) return;
      setSt(function (p) {
        var cols = p.cols.map(function (c) { return c.slice(); });
        cols[d.row][d.i] = a; cols[d.row][d.j] = b;
        return Object.assign({}, p, { cols: cols });
      });
    } else {
      var perH = d.h / Math.max(1, d.heights.length);
      var dh = (e.clientY - d.y) / perH;
      var x = d.heights[d.i] + dh;
      var y = d.heights[d.i + 1] - dh;
      if (x < 0.25 || y < 0.25) return;
      setSt(function (p) {
        var hs = p.heights.slice();
        hs[d.i] = x; hs[d.i + 1] = y;
        return Object.assign({}, p, { heights: hs });
      });
    }
  }, []);

  var onUp = useCallback(function () { dragRef.current = null; }, []);

  useEffect(function () {
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    return function () {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
  }, [onMove, onUp]);

  var n = st.slots.length;               // grid capacity (3 / 6 / 9)
  var liveCount = st.slots.filter(function (x) { return x !== null; }).length;
  var rows = rowsOf(n);
  var btn = function (active) {
    return {
      fontSize: 11, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit',
      borderRadius: 6, padding: '5px 12px',
      background: active ? 'rgba(56,189,248,0.14)' : 'transparent',
      color: active ? '#38bdf8' : '#8b98a9',
      border: '1px solid ' + (active ? 'rgba(56,189,248,0.5)' : '#26334a'),
    };
  };

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', color: '#e5e7eb', fontFamily: 'inherit' }}>
      <style>{'.ws-pane > div { max-width: 100% !important; width: 100% !important; padding-left: 10px !important; padding-right: 10px !important; }'}</style>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 14px', borderBottom: '1px solid #1f2937', flexWrap: 'wrap', flexShrink: 0 }}>
        <span style={{ fontSize: 15, fontWeight: 800 }}>Workspace</span>
        <div style={{ display: 'flex', gap: 5, marginLeft: 10, alignItems: 'center' }}>
          {[3, 6, 9].map(function (k) {
            return <button key={k} onClick={function () { setCount(k); }} style={btn(n === k && liveCount === k)}>{k} panes</button>;
          })}
          {liveCount !== n ? (
            <span style={{ fontSize: 11, fontWeight: 800, color: '#38bdf8', marginLeft: 4 }}>{liveCount} open</span>
          ) : null}
        </div>
        <div style={{ display: 'flex', gap: 5, marginLeft: 14, alignItems: 'center' }}>
          <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 0.8, color: '#556677' }}>REFRESH</span>
          {[1, 2, 5].map(function (m) {
            return <button key={m} onClick={function () { setSt(function (p) { return Object.assign({}, p, { mult: m }); }); }} style={btn(st.mult === m)}>{m === 1 ? 'Live' : m + '\u00d7'}</button>;
          })}
        </div>
        <span style={{ marginLeft: 'auto', fontSize: 9, color: '#556677' }}>
          panes share one request per endpoint · drag dividers · hover a pane to close it
        </span>
      </div>

      <div ref={wrapRef} style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, padding: 6 }}>
        {Array.from({ length: rows }).map(function (_, r) {
          var inRow = paneCountInRow(n, r);
          // Surviving columns in this row. A row whose panes are all closed
          // renders nothing, so its height is released to the other rows.
          var live = [];
          for (var lc = 0; lc < inRow; lc++) {
            if (st.slots[r * COLS + lc] !== null) live.push(lc);
          }
          if (!live.length) return null;
          return (
            <div key={'r' + r} style={{ display: 'contents' }}>
              <div style={{ flex: st.heights[r], display: 'flex', minHeight: 0 }}>
                {live.map(function (c, li) {
                  var idx = r * COLS + c;
                  var slot = st.slots[idx] || 'none';
                  var P = pageById(slot);
                  var Comp = P.el;
                  var z = (st.zoom || {})[idx] || 1;
                  return (
                    <div key={'c' + c} style={{ display: 'contents' }}>
                      <div style={{
                        flex: st.cols[r][c], minWidth: 0, display: 'flex', flexDirection: 'column',
                        background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 8,
                        overflow: 'hidden', position: 'relative',
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '5px 8px', borderBottom: '1px solid #131c2b', flexShrink: 0 }}>
                          <select value={slot} onChange={function (e) { setSlot(idx, e.target.value); }}
                            style={{ background: '#0d1524', border: '1px solid #26334a', borderRadius: 5, color: '#c4cfd8', fontSize: 11, padding: '3px 6px', fontFamily: 'inherit', maxWidth: 165 }}>
                            {PAGES.map(function (p) { return <option key={p.id} value={p.id}>{p.label}</option>; })}
                          </select>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <button onClick={function () { stepZoom(idx, -1); }} title="Zoom out"
                              disabled={z <= ZOOM_MIN + 0.001} style={zoomBtn(z <= ZOOM_MIN + 0.001)}>{'\u2212'}</button>
                            <span onClick={function () { setZoom(idx, 1); }} title="Reset to 100%"
                              style={{ fontSize: 9, color: '#6b7a8d', minWidth: 30, textAlign: 'center', cursor: 'pointer', fontVariantNumeric: 'tabular-nums' }}>
                              {Math.round(z * 100)}%
                            </span>
                            <button onClick={function () { stepZoom(idx, 1); }} title="Zoom in"
                              disabled={z >= ZOOM_MAX - 0.001} style={zoomBtn(z >= ZOOM_MAX - 0.001)}>+</button>
                          </div>
                          {/* Hot-zone: hovering anywhere else in the pane does
                              nothing. Only this top-right corner reveals the
                              close control, so a stray mouse crossing the pane
                              cannot surface a destructive button. */}
                          <div
                            onMouseEnter={function () { setHover(idx); }}
                            onMouseLeave={function () { setHover(-1); }}
                            style={{ marginLeft: 'auto', width: 34, height: 22, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                            {hover === idx && liveCount > 1 ? (
                              <button onClick={function () { closePane(idx); }} title="Close pane"
                                style={{
                                  cursor: 'pointer', fontFamily: 'inherit',
                                  background: 'rgba(239,68,68,0.14)', color: '#ef4444',
                                  border: '1px solid rgba(239,68,68,0.45)', borderRadius: 5,
                                  fontSize: 12, fontWeight: 800, lineHeight: 1, padding: '3px 7px',
                                }}>{'\u00d7'}</button>
                            ) : null}
                          </div>
                        </div>
                        <div className="ws-pane" style={{
                          flex: 1, overflow: 'auto', minHeight: 0,
                          zoom: z !== 1 ? z : undefined,
                        }}>
                          {Comp ? <Comp {...(P.props || {})} /> : (
                            <div style={{ padding: 20, fontSize: 11, color: '#556677' }}>Pick a page above.</div>
                          )}
                        </div>
                      </div>
                      {li < live.length - 1 ? (
                        <div onMouseDown={onDown('col', r, c, live[li + 1])}
                          style={{ width: 7, cursor: 'col-resize', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          <div style={{ width: 3, height: 34, borderRadius: 2, background: '#26334a' }} />
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
              {r < rows - 1 ? (
                <div onMouseDown={onDown('row', 0, r)}
                  style={{ height: 7, cursor: 'row-resize', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <div style={{ height: 3, width: 34, borderRadius: 2, background: '#26334a' }} />
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Workspace;
